/* */ 
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function(it) {
  return IObject(defined(it));
};
